import { View } from "binder"
import { DistrictSelector } from "../districtManipulation/districtSelector";
import { DistrictEditorViewModel } from "./districtEditor-viewModel"

export class DistrictEditorView extends View<DistrictEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-B088568B-FD80-48A8-8014-868611347751"
    }
    loadHtml(): string {
        let element = require('./districtEditor.html').default;
        let style = require('./districtEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
